var slidebars;

(function($) {
    slidebars = function () {
        /**
         * Setup
         */
        var canvas = $('[data-canvas]'),
            offCanvas = {},
            init = false,
            registered = false,
            sides = [ 'top', 'right', 'bottom', 'left' ],
            styles = [ 'reveal', 'push', 'overlay', 'shift', 'fade' ],
            getAnimationProperties = function (id) {
                var elements = $(),
                    amount = '0px, 0px',
                    duration = parseFloat(offCanvas[id].element.css('transitionDuration'), 10) * 1000;

                if (offCanvas[id].style === 'reveal' || offCanvas[id].style === 'push' || offCanvas[id].style === 'shift') {
                    elements = elements.add(canvas);
                }
                if (offCanvas[id].style === 'push' || offCanvas[id].style === 'overlay' || offCanvas[id].style === 'shift') {
                    elements = elements.add(offCanvas[id].element);
                }

                if (offCanvas[id].active) {
                    if (offCanvas[id].side === 'top') {
                        amount = '0px, ' + offCanvas[id].element.css('height');
                    } else if (offCanvas[id].side === 'right') {
                        amount = '-' + offCanvas[id].element.css('width') + ', 0px';
                    } else if (offCanvas[id].side === 'bottom') {
                        amount = '0px, -' + offCanvas[id].element.css('height');
                    } else if (offCanvas[id].side === 'left') {
                        amount = offCanvas[id].element.css('width') + ', 0px';
                    }
                }

                return { elements: elements, amount: amount, duration: duration };
            },
            registerSlidebar = function (id, side, style, element) {
                if (isRegisteredSlidebar(id)) {
                    throw "Error registering Slidebar, a Slidebar with id '" + id + "' already exists.";
                }
                offCanvas[id] = {
                    id: id,
                    side: side,
                    style: style,
                    element: element,
                    active: false
                };
            },
            isRegisteredSlidebar = function (id) {
                return offCanvas.hasOwnProperty(id);
            };

        /**
         * Initialization
         */
        this.init = function (callback) {
            if (init) {
                throw "Slidebars has already been initialized.";
            }
            if (!registered) {
                $('[data-off-canvas]').each(function () {
                    var parameters = $(this).attr('data-off-canvas').split(' ', 3);
                    if (!parameters || !parameters[0] || sides.indexOf(parameters[1]) === -1 || styles.indexOf(parameters[2]) === -1) {
                        throw "Error registering Slidebar, please specifiy a valid id, side and style'.";
                    }
                    registerSlidebar(parameters[0], parameters[1], parameters[2], $(this));
                });
                registered = true;
            }
            init = true;
            this.css();
            $(events).trigger('init');
            if (typeof callback === 'function') {
                callback();
            }
        };

        this.exit = function (callback) {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            var exit = function () {
                init = false;
                $(events).trigger('exit');
                if (typeof callback === 'function') {
                    callback();
                }
            };
            if (this.getActiveSlidebar()) {
                this.close(exit);
            } else {
                exit();
            }
        };

        /**
         * CSS
         */
        this.css = function (callback) {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            for (var id in offCanvas) {
                if (isRegisteredSlidebar(id)) {
                    var offset;
                    if (offCanvas[id].side === 'top' || offCanvas[id].side === 'bottom') {
                        offset = offCanvas[id].element.css('height');
                    } else {
                        offset = offCanvas[id].element.css('width');
                    }
                    if (offCanvas[id].style === 'push' || offCanvas[id].style === 'overlay' || offCanvas[id].style === 'shift') {
                        offCanvas[id].element.css('margin-' + offCanvas[id].side, '-' + offset);
                    }
                }
            }
            if (this.getActiveSlidebar()) {
                this.open(this.getActiveSlidebar());
            }
            $(events).trigger('css');
            if (typeof callback === 'function') {
                callback();
            }
        };

        /**
         * Controls
         */
        this.open = function (id, callback) {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            if (!id) {
                throw "You must pass a Slidebar id.";
            }
            if (!isRegisteredSlidebar(id)) {
                throw "Error opening Slidebar, there is no Slidebar with id '" + id + "'.";
            }

            var openAnimation = function () {
                offCanvas[id].active = true;
                offCanvas[id].element.css('display', 'block');
                $(events).trigger('opening', [offCanvas[id].id]);

                if (offCanvas[id].style === 'fade') {
                    // Determine the animation class based on side.
                    var animationClass = (offCanvas[id].side === 'left') ? 'animate__fadeIn' :
                                         (offCanvas[id].side === 'right') ? 'animate__fadeInRight' :
                                         (offCanvas[id].side === 'top') ? 'animate__fadeInDown' :
                                         (offCanvas[id].side === 'bottom') ? 'animate__fadeInUp' : 'animate__fadeInLeft';

                    // Add Animate.css classes to trigger the fade in.
                    offCanvas[id].element.addClass('animate__animated ' + animationClass);

                    // Listen for the end of the animation.
                    offCanvas[id].element.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
                        $(events).trigger('opened', [offCanvas[id].id]);
                        if (typeof callback === 'function') {
                            callback();
                        }
                    });
                } else {
                    // Existing behavior for other styles
                    var animationProperties = getAnimationProperties(id);
                    animationProperties.elements.css({
                        'transition-duration': animationProperties.duration + 'ms',
                        'transform': 'translate(' + animationProperties.amount + ')'
                    });
                    setTimeout(function () {
                        $(events).trigger('opened', [offCanvas[id].id]);
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }, animationProperties.duration);
                }
            };

            if (this.getActiveSlidebar() && this.getActiveSlidebar() !== id) {
                this.close(openAnimation);
            } else {
                openAnimation();
            }
        };

        this.close = function (id, callback) {
			if (typeof id === 'function') {
				callback = id;
				id = null;
			}
			if (!init) {
				throw "Slidebars hasn't been initialized.";
			}
			if (id && !isRegisteredSlidebar(id)) {
				throw "Error closing Slidebar, there is no Slidebar with id '" + id + "'.";
			}
			if (!id) {
				id = this.getActiveSlidebar();
			}
			if (id && offCanvas[id].active) {
				// ✅ Fix: Instantly mark as false so resize events ignore it immediately
				offCanvas[id].active = false; 

				if (offCanvas[id].style === 'fade') {
					var animationClass = (offCanvas[id].side === 'left') ? 'animate__fadeOut' :
										(offCanvas[id].side === 'right') ? 'animate__fadeOutRight' :
										(offCanvas[id].side === 'top') ? 'animate__fadeOutUp' :
										(offCanvas[id].side === 'bottom') ? 'animate__fadeOutDown' : 'animate__fadeOutLeft';

					offCanvas[id].element
						.removeClass('animate__animated fadeInLeft fadeInRight fadeInUp fadeInDown')
						.addClass('animate__animated ' + animationClass);

					$(events).trigger('closing', [offCanvas[id].id]);

					offCanvas[id].element.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
						offCanvas[id].element.css('display', '');
						$(events).trigger('closed', [offCanvas[id].id]);
						offCanvas[id].element.removeClass('animated ' + animationClass);
						if (typeof callback === 'function') {
							callback();
						}
					});
				} else {
					$(events).trigger('closing', [offCanvas[id].id]);
					var animationProperties = getAnimationProperties(id);
					animationProperties.elements.css('transform', '');
					
					setTimeout(function () {
						animationProperties.elements.css('transition-duration', '');
						offCanvas[id].element.css('display', '');
						$(events).trigger('closed', [offCanvas[id].id]);
						if (typeof callback === 'function') {
							callback();
						}
					}, animationProperties.duration);
				}
			}
		};

        this.toggle = function (id, callback) {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            if (!id) {
                throw "You must pass a Slidebar id.";
            }
            if (!isRegisteredSlidebar(id)) {
                throw "Error toggling Slidebar, there is no Slidebar with id '" + id + "'.";
            }
            if (offCanvas[id].active) {
                this.close(id, function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            } else {
                this.open(id, function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }
        };

        /**
         * Active States
         */
        this.isActive = function () {
            return init;
        };

        this.isActiveSlidebar = function (id) {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            if (!id) {
                throw "You must provide a Slidebar id.";
            }
            if (!isRegisteredSlidebar(id)) {
                throw "Error retrieving Slidebar, there is no Slidebar with id '" + id + "'.";
            }
            return offCanvas[id].active;
        };

        this.getActiveSlidebar = function () {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            var active = false;
            for (var id in offCanvas) {
                if (isRegisteredSlidebar(id)) {
                    if (offCanvas[id].active) {
                        active = offCanvas[id].id;
                        break;
                    }
                }
            }
            return active;
        };

        this.getSlidebars = function () {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            var slidebarsArray = [];
            for (var id in offCanvas) {
                if (isRegisteredSlidebar(id)) {
                    slidebarsArray.push(offCanvas[id].id);
                }
            }
            return slidebarsArray;
        };

        this.getSlidebar = function (id) {
            if (!init) {
                throw "Slidebars hasn't been initialized.";
            }
            if (!id) {
                throw "You must pass a Slidebar id.";
            }
            if (!isRegisteredSlidebar(id)) {
                throw "Error retrieving Slidebar, there is no Slidebar with id '" + id + "'.";
            }
            return offCanvas[id];
        };

        /**
         * Events
         */
        this.events = {};
        var events = this.events;

        $(window).on('resize', this.css.bind(this));
    };

    // Slidebars Init.
    var controller = new slidebars();
    controller.init();

    // NEW: track last focused element before opening nav
    var lastFocusedElement = null;

    // Helper: move focus into the nav slidebar
    function moveFocusIntoNavSlidebar() {
        // Adjust selector if your data-off-canvas attribute differs
        var $panel = $('[data-off-canvas^="nav-slidebar"]');

        if (!$panel.length) {
            return;
        }

        // Prefer a dedicated skip link if present
        var $focusTarget = $panel.find('.skip-link').first();

        if (!$focusTarget.length) {
            // Fallback to first naturally focusable element
            $focusTarget = $panel.find(
                'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            ).first();
        }

        if ($focusTarget.length) {
            // Ensure it can be focused programmatically
            if (!$focusTarget.attr('tabindex')) {
                $focusTarget.attr('tabindex', '-1');
            }
            $focusTarget.focus();
        }
    }

    // Custom Select & Preselect Handling
    $('.ctrl-mobile-toggle').on('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
        console.log('clicked');

        // Remember where focus was before opening
        lastFocusedElement = document.activeElement;

        $('.nav-overlay').toggleClass('active');
        $('body').toggleClass('menu-open');
        controller.toggle('nav-slidebar');
    });

    // Slidebars Event Handling
    $(controller.events).on('opening', function (event) {
        $('[data-canvas]').addClass('js-close-any');
    });

    $(controller.events).on('opened', function (event, id) {
        if (id === 'nav-slidebar') {
            // Programmatically move focus into the nav panel.
            moveFocusIntoNavSlidebar();
        }
    });

    $(controller.events).on('closing', function (event) {
        $('[data-canvas]').removeClass('js-close-any');
    });

    $(controller.events).on('closed', function (event, id) {
        if (id === 'nav-slidebar' && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            // Restore focus to the element that triggered the menu
            lastFocusedElement.focus();
        }
    });

    $(document).on('click', '.js-close-any', function (event) {
        if (controller.getActiveSlidebar()) {
            event.preventDefault();
            event.stopPropagation();
            $('.nav-overlay').removeClass('active');
            $('body').removeClass('menu-open');
            controller.close();
        }
    });

    $('.menu-close').on('click', function (event) {
        $('.nav-overlay').removeClass('active');
        $('body').removeClass('menu-open');
        controller.close('nav-slidebar');
    });
})(jQuery);

document.addEventListener('DOMContentLoaded', function() {
	// Only target parent links inside the MOBILE nav:
	// .nav-slidebar .nav-primary-menu li.menu-item-has-children > a
	const parentLinks = document.querySelectorAll(
		'.nav-slidebar .nav-primary-menu li.menu-item-has-children > a'
	);
  
	parentLinks.forEach(function(link) {
		link.addEventListener('click', function(event) {
			// Prevent the default link action so it just toggles the submenu
			event.preventDefault();
  
			// Get the parent li element
			const parentItem = link.parentElement;
			// Assume the sub-menu is the next sibling element (usually an <ul>)
			const subMenu = link.nextElementSibling;
  
			if (subMenu) {
				// Toggle a CSS class (e.g., "open") on the sub-menu to control its visibility
				subMenu.classList.toggle('open');
  
				// Also toggle the class on the parent li to change arrow direction via CSS
				parentItem.classList.toggle('open');
			}
		});
	});
});

document.addEventListener('DOMContentLoaded', () => {
    
    const initGalleryMod = () => {
        const featuredContainer = document.querySelector('.gspro-c-media-gallery__featured');
        const thumbnails = document.querySelectorAll('.gspro-o-thumb--lg');

        if (!featuredContainer || thumbnails.length === 0) {
            return false;
        }

        // 1. Apply the class to the featured container immediately on load
        featuredContainer.classList.add('has-light-clay-background-color');

        // 2. NEW: Permanently apply the class to the FIRST thumbnail
        thumbnails[0].classList.add('has-light-clay-background-color');

        // 3. Handle the click events for the featured container
        thumbnails.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                
                if (index === 0) {
                    // Re-apply to featured container when first thumb is clicked
                    featuredContainer.classList.add('has-light-clay-background-color');
                } else {
                    // Remove from featured container for all other thumbs
                    featuredContainer.classList.remove('has-light-clay-background-color');
                }
                
            });
        });

        return true; 
    };

    if (!initGalleryMod()) {
        const checkInterval = setInterval(() => {
            if (initGalleryMod()) {
                clearInterval(checkInterval);
            }
        }, 500);

        setTimeout(() => {
            clearInterval(checkInterval);
        }, 10000);
    }
});